import React, { useEffect, useState, useRef } from "react";
import styles from './Home.module.css';

export default function ImageSwitcher({imgPathArray,stateValue,specificStyle,sectionInView}){

    const length = imgPathArray.length;

    const [bannerImg,setBannerImg] = useState(0);
    const intervalRef = useRef(null);
    const wasInViewRef = useRef(false);

    useEffect(() => {
        // Reset slideshow when section enters view
        if(sectionInView && !wasInViewRef.current){
            setBannerImg(0);
            wasInViewRef.current = true;
        }
        
        // Stop slideshow when section is not in view
        if(!sectionInView){
            wasInViewRef.current = false;
            if(intervalRef.current){
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            return;
        }

        // Start slideshow when section is in view
        if(sectionInView && !intervalRef.current){
            intervalRef.current = setInterval(() => {
                setBannerImg((prev) => {
                    if(prev < length - 1){
                        return Number(prev)+1;
                    } else {
                        return 0;
                    }
                })
            },5000);
        }

        return () => {
            if(intervalRef.current){
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }
    },[length, sectionInView]);

    return (
        <>
            {imgPathArray.map((imgPath, index) => {
                if(typeof imgPath === 'object' && imgPath !== null){
                    const backgroundSize = imgPath.size || 'cover';
                    return (
                        <div key={index} style={{top: stateValue.top}} className={`${styles.sectionImgContainer}`}>
                            <div style={{opacity: `${bannerImg === index? 1 : 0}`,backgroundImage: `url(${imgPath.img})`,backgroundPosition: `${imgPath.pos}`,backgroundSize: backgroundSize}} className={`${styles.sectionImg} ${specificStyle}`}></div>
                        </div>
                    )
                } else if (typeof imgPath !== 'object' && imgPath !== null){
                    return (
                        <div key={index} style={{top: stateValue.top}} className={`${styles.sectionImgContainer}`}>
                            <div style={{opacity: `${bannerImg === index? 1 : 0}`,backgroundImage: `url(${imgPath})`}} className={`${styles.sectionImg} ${specificStyle}`}></div>
                        </div>
                    )
                }
                return null;
            })}
           
        </>
    )
}